import { SHAPE_STROKE_PROPS } from './stroke-props';

interface PentagonProps {
  strokeDasharray: string | undefined;
}

export default function Pentagon({ strokeDasharray }: PentagonProps) {
  return (
    <polygon
      points="50,0 100,38 81,100 19,100 0,38"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
